import React from "react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock";

const Services = () => {
  return (
    <section id="services" className="icg-section icg-dark">
      <div className="icg-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="icg-eyebrow" style={{ color: "rgba(245,241,234,0.6)" }}>
              <span className="icg-dot" /> Services
            </span>
            <h2 className="font-display font-semibold tracking-tight mt-5"
                style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}>
              What we do,
              <br />
              <span className="font-serif-it text-[color:var(--icg-accent)]">end to end</span>.
            </h2>
          </div>
          <p className="max-w-sm text-[color:var(--icg-cream)]/70 leading-relaxed">
            Six core capabilities. One team. Every project shaped by 20 years of hands-on work with
            small businesses across the US and beyond.
          </p>
        </div>

        <div className="mt-16 border-t border-[color:var(--icg-cream)]/15">
          {services.map((s, i) => (
            <a
              key={s.id}
              href="#contact"
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-8 md:py-10 border-b border-[color:var(--icg-cream)]/15 hover:bg-[color:var(--icg-cream)]/[0.03] transition-colors"
            >
              <div className="md:col-span-1 font-display text-sm text-[color:var(--icg-cream)]/50 pt-2">
                0{i + 1}
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display font-semibold tracking-tight text-3xl md:text-4xl group-hover:text-[color:var(--icg-accent)] transition-colors">
                  {s.title}
                </h3>
                <p className="mt-1 text-sm text-[color:var(--icg-cream)]/60">{s.subtitle}</p>
              </div>
              <div className="md:col-span-5 text-[color:var(--icg-cream)]/80 leading-relaxed">
                {s.description}
                <div className="mt-4 flex flex-wrap gap-2">
                  {s.features.map((f) => (
                    <span
                      key={f}
                      className="text-xs px-3 py-1 rounded-full border border-[color:var(--icg-cream)]/20 text-[color:var(--icg-cream)]/80"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
              <div className="md:col-span-2 flex md:justify-end items-start">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[color:var(--icg-cream)]/25 group-hover:bg-[color:var(--icg-accent)] group-hover:border-[color:var(--icg-accent)] group-hover:text-[color:var(--icg-ink)] transition-all">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
